// extracted by mini-css-extract-plugin
export default {"button":"jhxhad","expand":"wx04vM","suffixIcon":"a9mROj","colorFromFullButton":"XGONup","colorFromHollowButton":"Y8oRYj"};